import {PluginFunction} from 'vue';

import { sortBy, groupBy, intersection, kebabCase } from 'lodash-es';

export const Lodash: PluginFunction<never> = (Vue) => {
	Vue.prototype._ = {
		sortBy,
		groupBy,
		intersection,
		kebabCase
	};
}

declare module "vue/types/vue" {
	interface Vue {
		_: {
			sortBy: typeof sortBy,
			groupBy: typeof groupBy,
			intersection: typeof intersection,
			kebabCase: typeof kebabCase
		}
	}
}
